import { render } from "./AppShell.vue?vue&type=template&id=ba713700&scoped=true"
import script from "./AppShell.vue?vue&type=script&lang=js"
export * from "./AppShell.vue?vue&type=script&lang=js"

import "./AppShell.vue?vue&type=style&index=0&id=ba713700&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba713700"]])

export default __exports__